/** Required on every web page — sticks to the viewport bottom on short pages. */
export function Footer() {
  return (
    <footer
      className="mt-auto flex items-center justify-between border-t px-8 py-4 text-xs"
      style={{
        background: "var(--footer-bg)",
        borderColor: "var(--accent-subtle)",
        color: "var(--text-tertiary)",
      }}
    >
      <span>© 2025 Otzem Chassid Eye Clinic. All rights reserved.</span>
      <span>
        Built &amp; Designed by{" "}
        <span className="font-semibold" style={{ color: "var(--accent-light)" }}>
          GILAD SHALOM
        </span>
      </span>
    </footer>
  );
}
